import React from "react";

import { Stack } from "@mui/material";
import { CashflowForecastSummary } from "components/Deal-insights/CashflowForecastSummary";
import { ForecastPredictionTable } from "components/Deal-insights/ForecastPredictionTable";
import { InsightsBreadcrumb } from "components/Deal-insights/InsightsBreadcrumb";
import { useDealForecast } from "components/Deal-insights/use-deal-forecast";
import { staticReportsQueries } from "constants/reports";

export const CashflowForecastFull: React.FC = () => {
  const forecast = useDealForecast({ withTable: true });

  return (
    <Stack sx={{ p: "16px", gap: "16px", flexGrow: 1, overflow: "hidden", backgroundColor: "#f6f8fc" }}>
      <InsightsBreadcrumb current="Cashflow Forecast" title="Cashflow Forecast" />

      {/* Only this content area scrolls; the breadcrumb header stays fixed. */}
      <Stack sx={{ gap: "16px", flexGrow: 1, minHeight: 0, overflowY: "auto" }}>
        <Stack sx={{ p: "16px", borderRadius: "8px", boxShadow: "0px 1px 2px rgba(18, 18, 23, 0.1)", bgcolor: "#fff" }}>
          <CashflowForecastSummary
            loading={forecast.loading}
            error={forecast.error}
            isEmpty={forecast.isEmpty}
            graph={forecast.graph}
            onRetry={forecast.refetch}
            height={360}
          />
        </Stack>

        {/* Table on bottom */}
        {!forecast.error && !forecast.isEmpty && (
          <Stack
            sx={{ p: "16px", borderRadius: "8px", boxShadow: "0px 1px 2px rgba(18, 18, 23, 0.1)", bgcolor: "#fff" }}
          >
            <ForecastPredictionTable
              data={forecast.table}
              loading={forecast.loading}
              currency={staticReportsQueries.currency}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
